/**
 * Which release this bundle is — the git tag it was built from, or `dev`.
 * Replaced at build time by `define` in `vite.config.ts`.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;
